import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const ContractSourceSelectionModal = ({ isOpen, onClose, contractTypeConfig, onSelectSource }) => {
  if (!isOpen) return null;

  const sources = [
    {
      id: 'new',
      icon: 'FilePlus',
      label: 'عقد جديد',
      description: 'إنشاء عقد جديد من البداية',
      color: '#10B981',
      bgGradient: 'linear-gradient(135deg, rgba(16, 185, 129, 0.2) 0%, rgba(16, 185, 129, 0.1) 100%)'
    },
    {
      id: 'archive',
      icon: 'Archive',
      label: 'أرشيف العقود',
      description: 'اختيار عقد من الأرشيف',
      color: '#F59E0B',
      bgGradient: 'linear-gradient(135deg, rgba(245, 158, 11, 0.2) 0%, rgba(245, 158, 11, 0.1) 100%)'
    }
  ];

  const handleSourceSelect = (sourceId) => {
    onSelectSource(sourceId);
  };

  return (
    <>
      <div className="fixed inset-0 bg-black/70 backdrop-blur-sm z-[10004]" onClick={onClose} />
      <div 
        className="fixed z-[10005] bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 rounded-2xl shadow-2xl border-2 w-full max-w-2xl mx-4 max-h-[90vh] overflow-y-auto"
        style={{
          borderColor: contractTypeConfig?.type?.color || '#8B5CF6',
          left: '50%',
          top: '50%',
          transform: 'translate(-50%, -50%)'
        }}
      >
        <div className="p-6" dir="rtl">
          {/* Header */}
          <div className="flex items-center justify-between mb-6">
            <div className="flex items-center gap-3">
              <div 
                className="p-3 rounded-lg"
                style={{ backgroundColor: `${contractTypeConfig?.type?.color}20` }}
              >
                <Icon name={contractTypeConfig?.type?.icon} size={28} color={contractTypeConfig?.type?.color} />
              </div>
              <div>
                <h3 className="text-xl font-bold text-white">{contractTypeConfig?.type?.label}</h3>
                <p className="text-sm text-gray-400">اختر مصدر العقد</p>
              </div>
            </div>
            <button onClick={onClose} className="p-2 hover:bg-gray-700 rounded-lg transition-colors">
              <Icon name="X" size={20} color="#9CA3AF" />
            </button>
          </div>

          {/* Contract Type Info */}
          <div className="mb-6 p-4 rounded-xl border border-gray-700 bg-gray-800/50">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <Icon name="Info" size={18} color="#8B5CF6" />
                <span className="text-white font-medium">معلومات العقد المحدد</span>
              </div>
            </div>
            <div className="mt-3 grid grid-cols-2 gap-3">
              <div className="flex items-center gap-2">
                <Icon name="FileText" size={16} color="#9CA3AF" />
                <span className="text-sm text-gray-400">النوع:</span>
                <span className="text-sm text-white font-medium">{contractTypeConfig?.type?.label}</span>
              </div>
              <div className="flex items-center gap-2">
                <Icon name="DollarSign" size={16} color="#9CA3AF" />
                <span className="text-sm text-gray-400">الرسوم:</span>
                <span className="text-sm text-white font-medium">
                  {contractTypeConfig?.feeValue}{contractTypeConfig?.feeType === 'percentage' ? '%' : ' دينار'}
                </span>
              </div>
            </div>
          </div>

          {/* Source Selection */}
          <div className="mb-6">
            <h4 className="text-white font-semibold mb-4 text-right">اختر مصدر العقد</h4>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              {sources?.map((source) => (
                <div
                  key={source?.id}
                  onClick={() => handleSourceSelect(source?.id)}
                  className="p-6 rounded-xl border-2 border-gray-700 bg-gray-800/50 hover:border-gray-600 cursor-pointer transition-all hover:scale-105 group"
                  style={{
                    background: source?.bgGradient
                  }}
                >
                  <div className="flex flex-col items-center text-center gap-3">
                    <div 
                      className="p-4 rounded-xl transition-transform group-hover:scale-110"
                      style={{ backgroundColor: `${source?.color}30` }}
                    >
                      <Icon name={source?.icon} size={32} color={source?.color} />
                    </div>
                    <div>
                      <h5 className="text-white font-bold text-lg mb-1">{source?.label}</h5>
                      <p className="text-sm text-gray-400">{source?.description}</p>
                    </div>
                    <div className="mt-2 px-4 py-2 rounded-lg bg-gray-900/50 border border-gray-700 group-hover:border-gray-600 transition-colors">
                      <span className="text-sm text-white font-medium">اختيار</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Info Box */}
          <div className="p-4 rounded-xl bg-blue-600/10 border border-blue-500/30">
            <div className="flex items-start gap-3">
              <Icon name="Info" size={18} color="#3B82F6" />
              <div className="flex-1">
                <p className="text-sm text-blue-300 leading-relaxed">
                  <strong>عقد جديد:</strong> ابدأ بإنشاء عقد جديد من البداية مع جميع الحقول الفارغة.<br/>
                  <strong>أرشيف العقود:</strong> اختر عقد سابق من الأرشيف لاستخدامه كقالب أو للتعديل عليه.
                </p>
              </div>
            </div>
          </div>

          {/* Action Buttons */}
          <div className="flex gap-3 mt-6">
            <button
              onClick={onClose}
              className="flex-1 py-3 rounded-lg font-semibold text-white bg-gray-700 hover:bg-gray-600 transition-colors"
            >
              إلغاء
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default ContractSourceSelectionModal;